export type MenuItemType = {
  key: string;
  rolekey?: string;
  label: string;
  moduleName?: string;
  isTitle?: boolean;
  icon?: string;
  url?: string;
  screenName?: string;
  showSearchDropDown?: boolean;
  showChildren?: boolean;
  badge?: {
    variant: string;
    text: string;
  };
  parentKey?: string;
  isDisabled?: boolean;
  collapsed?: boolean;
  children?: MenuItemType[];
  screenRouteURL?: string[];
  screenId?: any;
};

export type SubMenus = {
  item: MenuItemType;
  linkClassName?: string;
  subMenuClassName?: string;
  activeMenuItems?: Array<string>;
  toggleMenu?: (item: MenuItemType, status: boolean) => void;
  className?: string;
};

export const MENU_ITEMS: MenuItemType[] = [
  {
    key: 'nav',
    label: 'Navigation',
    rolekey: 'nav',
    isTitle: true,
  },
  {
    key: 'dashboard',
    rolekey: 'dashboard',
    label: 'Dashboard',
    icon: 'ti ti-dashboard',
    url: '/dashboard',
    badge: {
      variant: 'success',
      text: '5',
    },
  },

  {
    key: 'admin-tools',
    rolekey: 'admin',
    label: 'Admin Panel',
    moduleName: 'Admin Portal',
    icon: 'ti ti-user',
    collapsed: true,
    showChildren: true,
    children: [
      {
        key: 'user-list',
        label: 'User Management',
        screenName: 'User Management',
        url: '/dashboard/admin/user-list',
        icon: 'ti ti-users',
        parentKey: 'admin',
        screenRouteURL: ['/dashboard/admin/add-user'],
      },
      {
        key: 'admin',
        rolekey: 'admin',
        label: 'Practice Management',
        screenName: 'Practice Management',
        icon: 'ti ti-building-hospital',
        url: '/dashboard/admin/practices',
        screenRouteURL: ['/dashboard/admin/add-practice'],
      },
      {
        key: 'Module Screen Entry',
        label: 'Module/Screen',
        screenName: 'Module/Screen Management',
        url: '/dashboard/admin/module-screen-list',
        icon: 'ti ti-user-screen',
        parentKey: 'admin',
        screenRouteURL: ['/dashboard/admin/add-module-screen'],
      },
      {
        key: 'Group List',
        label: 'Role Management',
        screenName: 'Role Management',
        url: '/dashboard/admin/group-list',
        icon: 'ti ti-user-check',
        parentKey: 'admin',
        screenRouteURL: ['/dashboard/admin/add-group-screen'],
      },
      {
        key: 'Appointment Type',
        label: 'Appointment Type',
        screenName: 'Appointment Type',
        url: '/dashboard/admin/appointment-type-list',
        icon: 'ti ti-calendar-clock',
        parentKey: 'admin',
        screenRouteURL: ['/dashboard/admin/add-appointment-type'],
      },

      {
        key: 'ICD Codes',
        label: 'ICD Codes',
        screenName: 'ICD Codes',
        icon: 'ti ti-source-code',
        url: '/dashboard/admin/add-icd-codes',
        parentKey: 'admin',
      },

      {
        key: 'CPT Code',
        label: 'CPT Codes',
        screenName: 'CPT Codes',
        icon: 'ti ti-file-code',
        url: '/dashboard/admin/add-cpt-code',
        parentKey: 'admin',
      },

      {
        key: 'set-office-timing',
        label: 'Office Timing',
        screenName: 'Office Timing',
        url: '/dashboard/admin/set-office-timing',
        icon: 'ti ti-clock-12',
        parentKey: 'admin',
      },
      // {
      //   key: 'Supplier',
      //   label: 'Supplier',
      //   screenName:'Supplier',
      //   url: '/dashboard/admin/add-supplier',
      //   icon: 'ti ti-user-up',
      //   parentKey: 'admin',
      // },
      {
        key: 'Insurance',
        label: 'Insurance',
        screenName: 'Insurance',
        url: '/dashboard/admin/add-insurance',
        icon: 'ti ti-coins',
        parentKey: 'admin',
      },
      {
        key: 'Twilio Number',
        label: 'Twilio Number',
        screenName: 'Twilio Number',
        url: '/dashboard/admin/add-twilio-number',
        icon: 'ti ti-numbers',
        parentKey: 'admin',
      },

      {
        key: 'Patient Goal SMART',
        label: 'Patient Goal SMART',
        screenName: 'Patient Goal SMART',
        url: '/dashboard/admin/patient-goal-list',
        icon: 'ti ti-target',
        parentKey: 'admin',
        screenRouteURL: ['/dashboard/admin/add-patient-goal'],
      },

      {
        key: 'Unassigned Patients',
        label: 'Unassigned Patients',
        screenName: 'Unassigned Patients',
        url: '/dashboard/admin/unassigned-patient-list',
        icon: 'ti ti-numbers',
        parentKey: 'admin',
      },
      {
        key: 'System Configurations',
        label: 'System Configurations',
        screenName: 'System Configurations',
        url: '/dashboard/admin/system-configurations',
        icon: 'ti ti-settings-heart',
        parentKey: 'admin',
      },
      {
        key: 'IVR Group',
        label: 'IVR Group',
        screenName: 'IVR Group',
        url: '/dashboard/admin/ivr-group',
        icon: 'ti ti-numbers',
        parentKey: 'admin',
      },
      {
        key: 'IVR Group Mapping',
        label: 'IVR Group Mapping',
        screenName: 'IVR Group Mapping',
        url: '/dashboard/admin/ivr-group-mapping',
        icon: 'ti ti-numbers',
        parentKey: 'admin',
      },
      {
        key: 'Extension Management',
        label: 'Extension Management',
        screenName: 'Extension Management',
        url: '/dashboard/admin/extension-management',
        icon: 'ti ti-calendar-clock',
        parentKey: 'admin',
      },
      {
        key: 'Critical Call Configuration',
        label: 'Critical Call Configuration',
        screenName: 'Critical Call Configuration',
        url: '/dashboard/admin/critical-call-configuration',
        icon: 'ti ti-phone-call',
        parentKey: 'admin',
      },
      // {
      //   key: 'Bulk Patient Readings',
      //   label: 'Bulk Patient Readings',
      //   screenName: 'Bulk Patient Readings',
      //   url: '/dashboard/admin/bulk-patient-readings',
      //   icon: 'ti ti-file-zip',
      //   parentKey: 'admin',
      // },
    ],
  },
  {
    key: 'admin',
    rolekey: 'admin',
    label: 'Practice Panel',
    moduleName: 'Admin Portal',
    icon: 'ti ti-hospital',
    collapsed: true,
    showChildren: false,
    showSearchDropDown: true,
    children: [
      {
        key: 'clinic-list',
        label: 'Clinic Management',
        screenName: 'Clinic Management',
        url: '/dashboard/admin/clinic-list',
        icon: 'ti ti-report-medical',
        parentKey: 'admin',
        screenRouteURL: ['/dashboard/admin/add-clinic'],
      },
      {
        key: 'doctor-list',
        label: 'Doctor Management',
        screenName: 'Doctor Management',
        url: '/dashboard/admin/doctor-list',
        icon: 'ti ti-user-cog',
        parentKey: 'admin',
        screenRouteURL: ['/dashboard/admin/add-doctor'],
      },
      {
        key: 'Patient',
        label: 'Patient Management',
        url: '/dashboard/admin/merge-patients',
        screenName: 'Patient Management',
        icon: 'ti ti-emergency-bed',
        parentKey: 'admin',
        screenRouteURL: ['/dashboard/admin/add-patient'],
      },

      {
        key: 'Patient Bulk',
        label: 'Patient Bulk',
        url: '/dashboard/admin/patient-bulk-list',
        screenName: 'Patient Bulk',
        icon: 'ti ti-users-plus',
        parentKey: 'admin',
        screenRouteURL: [
          '/dashboard/admin/add-patient-bulk',
          '/dashboard/admin/add-patient-bulk-list',
        ],
      },

      {
        key: 'Change Patient Clinic',
        label: 'Patients Transfer',
        screenName: 'Patients Transfer',
        url: '/dashboard/admin/change-patient-clinic',
        icon: 'ti ti-transfer',
        parentKey: 'admin',
      },
      {
        key: 'Care Coordinator',
        label: 'Assign Patients to CC',
        screenName: 'Assign Patients to CM',
        url: '/dashboard/admin/care-coordinator-list',
        icon: 'ti ti-user-code',
        parentKey: 'admin',
        screenRouteURL: [
          '/dashboard/admin/care-coordinator-list/detail',
          '/dashboard/admin/care-coordinator-list/detail/allocate',
        ],
      },

      // {
      //   key: 'Devices / Accessories',
      //   label: 'Devices / Accessories',
      //   screenName: 'Devices / Accessories',
      //   icon: 'ti ti-device-airtag',
      //   url: '/dashboard/admin/device-accessories',
      //   parentKey: 'admin',
      // },
      {
        key: 'Clinic Parameter',
        label: 'Thresholds Monitoring',
        screenName: 'Vitals Management',
        icon: 'ti ti-stethoscope',
        url: '/dashboard/admin/add-clinic-parameter',
        parentKey: 'admin',
      },
      {
        key: 'Merge Patients',
        label: 'Merge Patients',
        screenName: 'Merge Patients',
        url: '/dashboard/admin/add-merge-patients',
        icon: 'ti ti-user-up',
        parentKey: 'admin',
      },
      {
        key: 'Fax',
        label: 'Fax',
        screenName: 'Fax',
        url: '/dashboard/admin/fax',
        icon: 'ti ti-printer',
        parentKey: 'admin',
        screenRouteURL: [
          '/dashboard/admin/add-fax',
          '/dashboard/admin/fax-assign-patients',
        ],
      },
      {
        key: 'Caller ID',
        label: 'Caller ID',
        screenName: 'Caller ID',
        url: '/dashboard/admin/add-caller-id',
        icon: 'ti ti-numbers',
        parentKey: 'admin',
      },

    ],
  },
  {
    key: 'Onboarding',
    rolekey: 'patientOnBoarding',
    moduleName: 'Patient Onboarding',
    screenName: 'Consenting Dashboard',
    label: 'Consenting Dashboard',
    icon: 'ti ti-license',
    url: '/dashboard/patientonboarding/consenting-dashboard',
  },
  {
    key: 'Onboarding',
    rolekey: 'patientOnBoarding',
    moduleName: 'Patient Onboarding',
    screenName: 'Device Setup Dashboard',
    label: 'Device Setup Dashboard',
    icon: 'ti ti-devices',
    url: '/dashboard/patientonboarding/device-dashboard',
  },
  {
    key: 'Onboarding',
    rolekey: 'patientOnBoarding',
    moduleName: 'Patient Onboarding',
    screenName: 'Educational Calls Dashboard',
    label: 'Pending Educational Calls',
    icon: 'ti ti-phone',
    url: '/dashboard/patientonboarding/educational-call-dashboard',
  },
  {
    key: 'Onboarding',
    rolekey: 'patientOnBoarding',
    moduleName: 'Patient Onboarding',
    screenName: 'Twilio Make A Call',
    label: 'Twilio Make A Call',
    icon: 'ti ti-phone-plus',
    url: '/dashboard/patientonboarding/twilio-make-a-call',
  },
  {
    key: 'secure',
    rolekey: 'secure',
    moduleName: 'Secure Portal',
    screenName: 'Portal For HomeHealth',
    label: 'Portal For HomeHealth',
    icon: 'ti ti-home',
    url: '/dashboard/patientonboarding/home-health',
  },
  {
    key: 'secure',
    rolekey: 'secure',
    moduleName: 'Secure Portal',
    screenName: 'Portal For Other Programs',
    label: 'Portal For Other Programs',
    icon: 'ti ti-frame',
    url: '/dashboard/patientonboarding/other-programs',
  },

  // {
  //     key: 'Onboarding',
  //     label:"Patient Onboarding",
  //     rolekey: 'patientOnBoarding',
  //     moduleName:'Patient Onboarding',
  //     screenName:'Dashboard',
  //     icon: 'ti ti-users',
  //     showChildren:true,
  //     url: '/dashboard',
  //     collapsed: true,
  //     children: [
  //       {
  //         key: 'Onboarding',
  //         label: 'Consenting Dashboard',
  //         screenName:'Consenting Dashboard',
  //         icon: 'ti ti-dashboard',
  //         url: '/dashboard/patientonboarding/rpm-dashboard',
  //       },
  //       {
  //         key: 'Onboarding',
  //         label: 'Device Dashboard',
  //         screenName:'Device Setup Dashboard',
  //         icon: 'ti ti-dashboard',
  //         url: '/dashboard/patientonboarding/device-dashboard',
  //       },
  //       {
  //         key: 'Onboarding',
  //         label: 'Educational Dashboard',
  //         screenName:'Educational Calls Dashboard',
  //         icon: 'ti ti-dashboard',
  //         url: '/dashboard/patientonboarding/educational-call-dashboard',
  //       },
  //     ]
  // },
  {
    key: 'patient',
    rolekey: 'patient',
    label: 'Patient Portal',
    icon: 'ti ti-emergency-bed',
    collapsed: true,
    children: [],
  },
  // {
  //   key: 'care',
  //   rolekey: 'care',
  //   moduleName:'Care Management',
  //   screenName:'RPM Dashboard',
  //   label: 'RPM Dashboard',
  //   icon: 'ti ti-device-remote',
  //   url: '/dashboard/caremanager/rpm-dashboard',
  // },
  // {
  //   key: 'care',
  //   rolekey: 'care',
  //   moduleName: 'Care Management',
  //   screenName: 'RTM Dashboard',
  //   label: 'RTM Dashboard',
  //   icon: 'ti ti-heartbeat',
  //   url: '/dashboard/caremanager/rtm-dashboard',
  // },
  {
    key: 'care',
    rolekey: 'care',
    moduleName: 'Care Portal',
    screenName: 'CCM Dashboard',
    label: 'Care Dashboard',
    icon: 'ti ti-accessible',
    url: '/dashboard/caremanager/care-dashboard',
    screenRouteURL: ['/dashboard/caremanager/patient-profile']
  },
  {
    key: 'cocm-care-dashboard',
    rolekey: 'care',
    moduleName: 'Care Portal',
    screenName: 'CoCM Care Dashboard',
    label: 'CoCM Care Dashboard',
    icon: 'ti ti-brain',
    url: '/dashboard/caremanager/cocm-care-dashboard',
  },
  {
    key: 'care',
    rolekey: 'care',
    moduleName: 'Care Portal',
    screenName: 'NP Dashboard',
    label: 'NP Dashboard',
    icon: 'ti ti-nurse',
    url: '/dashboard/caremanager/nurse-practitioner-dashboard',
    screenRouteURL: ['/dashboard/caremanager/patient-profile']

  },
  {
    key: 'patient-registry',
    rolekey: 'care',
    moduleName: 'Care Portal',
    screenName: 'Patient Registry',
    label: 'Patient Registry',
    icon: 'ti ti-report-medical',
    url: '/dashboard/caremanager/patient-registry',
  },
    {
    key: 'goal-comparison',
    rolekey: 'care',
    moduleName: 'Care Portal',
    screenName: 'Goal Comparison',
    label: 'Goal Comparison',
    icon: 'ti ti-report-medical',
    url: '/dashboard/caremanager/goal-comparison',
  },
  //    {
  //   key: 'phyc-dashboard',
  //   rolekey: 'care',
  //   moduleName: 'Care Portal',
  //   screenName: 'Phyc Dashboard',
  //   label: 'Phyc Dashboard',
  //   icon: 'ti ti-brain',
  //   url: '/dashboard/caremanager/phyc-dashboard',
  // },
  //   {
  //   key: 'pcp-dashboard',
  //   rolekey: 'care',
  //   moduleName: 'Care Portal',
  //   screenName: 'PCP Dashboard',
  //   label: 'PCP Dashboard',
  //   icon: 'ti ti-stethoscope',
  //   url: '/dashboard/caremanager/pcp-dashboard',
  // },
  // {
  //   key: 'care',
  //   rolekey: 'care',
  //   moduleName: 'Care Management',
  //   screenName: 'PCM Dashboard',
  //   label: 'PCM Dashboard',
  //   icon: 'ti ti-brand-pnpm',
  //   url: '/dashboard/caremanager/pcm-dashboard',
  // },

  // {
  //   key: 'profileview', rolekey: 'care',
  //   screenName: 'Profile View',
  //   moduleName: 'Care Management',
  //   label: 'Profile View',
  //   icon: 'ti ti-license',
  //   url: '/dashboard/caremanager/profile-view',
  // },
  {
    key: 'callrecording',
    rolekey: 'care',
    screenName: 'Call Recording',
    moduleName: 'Care Portal',
    label: 'Call Recording',
    icon: 'ti ti-phone',
    url: '/dashboard/caremanager/call-recording',
  },
  {
    key: 'voicemails',
    rolekey: 'care',
    screenName: 'Voice Mails',
    moduleName: 'Care Portal',
    label: 'Voice Mails',
    icon: 'ti ti-record-mail',
    url: '/dashboard/caremanager/voice-recording',
  },
  {
    key: 'provider-patient',
    rolekey: 'care',
    screenName: 'Provider Patient',
    moduleName: 'Care Portal',
    label: 'Provider Patient',
    icon: 'ti ti-user-scan',
    url: '/dashboard/caremanager/provider-patient',
  },
  {
    key: 'nurse-practitioner',
    rolekey: 'care',
    moduleName: 'Care Portal',
    screenName: 'Nurse Practitioner',
    label: 'Nurse Practitioner',
    icon: 'ti ti-nurse',
    url: '/dashboard/caremanager/nurse-practitioner',
  },

  {
    key: 'non-compliant-patient-review',
    rolekey: 'care',
    moduleName: 'Care Portal',
    screenName: 'Non- Compliant Pre-Review  Patient List',
    label: 'Non-Compliance Pre-Review',
    icon: 'ti ti-file-isr',
    url: '/dashboard/caremanager/non-compliant-patient-review',
  },
  {
    key: 'non-compliant-final-patient-review',
    rolekey: 'care',
    moduleName: 'Care Portal',
    screenName: 'Non-Compliant Final Review Patient List',
    label: 'Non-Compliance Final Review',
    icon: 'ti ti-input-check',
    url: '/dashboard/caremanager/non-compliant-final-patient-review',
    screenRouteURL: ['/dashboard/caremanager/patient-profile']

  },
  {
    key: 'Non Compliant Completed Patient List',
    rolekey: 'care',
    moduleName: 'Care Portal',
    screenName: 'Non Compliant Completed Patient List',
    label: 'Non-Compliance Completed',
    icon: 'ti ti-progress-check',
    url: '/dashboard/caremanager/non-compliant-completed-patient-list',
  },
  {
    key: 'Compliance Device Issue List',
    rolekey: 'care',
    moduleName: 'Care Portal',
    screenName: 'Compliance Device Issue List',
    label: 'Compliance Device Issue',
    icon: 'ti ti-shield-check',
    url: '/dashboard/caremanager/compliance-device-issue',
  },
  {
    key: 'Device Return',
    rolekey: 'care',
    moduleName: 'Care Portal',
    screenName: 'Device Return',
    label: 'Device Return',
    icon: 'ti ti-device-ipad-cancel',
    url: '/dashboard/caremanager/device-return',
  },
  {
    key: 'Patient Search',
    rolekey: 'care',
    moduleName: 'Care Portal',
    screenName: 'Patient Search',
    label: 'Patient Search',
    icon: 'ti ti-world-search',
    url: '/dashboard/caremanager/patient-search',
  },
  {
    key: 'communication-logs',
    rolekey: 'care',
    moduleName: 'Care Portal',
    screenName: 'Communication Logs',
    label: 'Communication Logs',
    icon: 'ti ti-logs',
    url: '/dashboard/caremanager/communication-logs',
  },
  {
    key: 'twilio-make-a-call',
    rolekey: 'care',
    moduleName: 'Care Portal',
    screenName: 'Twilio Make A Call',
    label: 'Twilio Make A Call',
    icon: 'ti ti-phone-plus',
    url: '/dashboard/caremanager/twilio-make-a-call',
  },
  {
    key: 'reminder-sms',
    rolekey: 'care',
    moduleName: 'Care Portal',
    screenName: 'Reminder SMS',
    label: 'Reminder SMS',
    icon: 'ti ti-message',
    url: '/dashboard/caremanager/reminder-sms',
  },
  {
    key: 'device-retrieval-report',
    rolekey: 'care',
    moduleName: 'Care Portal',
    screenName: 'Device Retrieval Report',
    label: 'Device Retrieval Report',
    icon: 'ti ti-device-desktop-analytics',
    url: '/dashboard/caremanager/device-retrieval-report',
  },
    {
        key: 'Bulk Patient Readings',
        rolekey: 'care',
        label: 'Bulk Patient Readings',
        moduleName: 'Care Portal',
        screenName: 'Bulk Patient Readings',
        url: '/dashboard/caremanager/bulk-patient-readings',
        icon: 'ti ti-file-zip',
      },
  // {
  //   key: 'care',
  //   rolekey: 'care',
  //   label: 'Care managers',
  //   moduleName: 'Care Management',
  //   icon: 'ti ti-users',
  //   collapsed: true,
  //   showChildren: true,
  //   children: [
  //     {
  //       key: 'dashboard',
  //       label: 'Dashboard',
  //       screenName: 'Dashboard',
  //       // moduleName:'Care management',
  //       icon: 'ti ti-dashboard',
  //       url: '/dashboard/caremanager/dashboard',
  //     },
  //     {
  //       key: 'RPMdashboard',
  //       label: 'RPM Dashboard',
  //       screenName: 'RPM Dashboard',
  //       // moduleName:'Care management',
  //       icon: 'ti ti-dashboard',
  //       url: '/dashboard/caremanager/dashboard',
  //     },

  //     {
  //       key: 'non-compliant-provider-patient',
  //       screenName: 'Non Compliant Provider Patient',
  //       label: 'Non Compliant Provider Patient',
  //       icon: 'ti ti-license',
  //       url: '/dashboard/caremanager/non-compliant-provider-patient',
  //     },

  //   ],
  // },
  {
    key: 'logistic',
    rolekey: 'logistic',
    label: 'Logistic OTD',
    moduleName: 'Logistic Portal',
    icon: 'ti ti-users',
    collapsed: true,
    showChildren: true,
    children: [
      {
        key: 'supplier',
        label: 'Supplier',
        screenName: 'Supplier',
        url: '/dashboard/logistic/supplier-list',
        icon: 'ti ti-user-up',
        parentKey: 'logistic',
        screenRouteURL: ['/dashboard/logistic/add-supplier'],
      },
      {
        key: 'devices',
        label: 'Devices',
        screenName: 'Devices',
        url: '/dashboard/logistic/device-accessories-list',
        icon: 'ti ti-device-airtag',
        parentKey: 'logistic',
        screenRouteURL: ['/dashboard/logistic/add-devices'],
      },
      {
        key: 'accessories',
        label: 'Accessories',
        screenName: 'Accessories',
        url: '/dashboard/logistic/accessories-list',
        icon: 'ti ti-shredder',
        parentKey: 'logistic',
        screenRouteURL: ['/dashboard/logistic/device-accessories-add'],
      },
      {
        key: 'store',
        label: 'Store',
        screenName: 'Store',
        url: '/dashboard/logistic/add-store',
        icon: 'ti ti-brand-appstore',
        parentKey: 'logistic',
      },
      {
        key: 'courier',
        label: 'Courier',
        screenName: 'Courier',
        url: '/dashboard/logistic/add-courier',
        icon: 'ti ti-package-import',
        parentKey: 'logistic',
      },
      {
        key: 'device assigning process',
        label: 'Device Assigning Process',
        screenName: 'Device Assigning Process',
        url: '/dashboard/logistic/patient-device-assigning-process',
        icon: 'ti ti-progress-alert',
        parentKey: 'logistic',
      },
    ],
  },

  {
    key: 'logistic',
    rolekey: 'logistic',
    moduleName: 'Logistic Portal',
    screenName: 'Patient List Logistic Dashboard',
    label: 'Request Order',
    icon: 'ti ti-layers-selected',
    url: '/dashboard/logistic/patient-list-logistic-dashboard',
  },

  {
    key: 'logistic',
    rolekey: 'logistic',
    moduleName: 'Logistic Portal',
    screenName: 'Device Replacement',
    label: 'Device Replacement',
    icon: 'ti ti-replace',
    url: '/dashboard/logistic/device-replacement',
  },

  // {
  //   key: 'logistic',
  //   rolekey: 'logistic',
  //   moduleName: 'Logistic Portal',
  //   screenName: 'Return Order Dashboard',
  //   label: 'Return Order Dashboard',
  //   icon: 'ti ti-restore',
  //   url: '/dashboard/logistic/return-order-dashboard',
  // },

  {
    key: 'logistic',
    rolekey: 'logistic',
    moduleName: 'Logistic Portal',
    screenName: 'Device Retrieval',
    label: 'Device Retrieval',
    icon: 'ti ti-device-remote',
    url: '/dashboard/logistic/device-retrieval-dashboard',
  },

  {
    key: 'logistic',
    rolekey: 'logistic',
    moduleName: 'Logistic Portal',
    screenName: 'Additional Device',
    label: 'Additional Device',
    icon: 'ti ti-square-plus',
    url: '/dashboard/logistic/additional-device-dashboard',
  },


  {
    key: 'logistic',
    rolekey: 'logistic',
    moduleName: 'Logistic Portal',
    screenName: 'Purchase Order',
    label: 'Purchase Order',
    icon: 'ti ti-basket-bolt',
    url: '/dashboard/logistic/purchase-order-list',
    screenRouteURL: ['/dashboard/logistic/purchase-order'],
  },
  {
    key: 'logistic',
    rolekey: 'logistic',
    moduleName: 'Logistic Portal',
    screenName: 'Goods Receiving',
    label: 'Goods Receiving',
    icon: 'ti ti-tir',
    url: '/dashboard/logistic/goods-receiving-list',
    screenRouteURL: ['/dashboard/logistic/goods-receiving'],
  },
  {
    key: 'logistic',
    rolekey: 'logistic',
    moduleName: 'Logistic Portal',
    screenName: 'Return Receiving',
    label: 'Return Receiving',
    icon: 'ti ti-wrecking-ball',
    url: '/dashboard/logistic/return-receiving-list',
    screenRouteURL: ['/dashboard/logistic/return-receiving'],
  },
  {
    key: 'logistic',
    rolekey: 'logistic',
    moduleName: 'Logistic Portal',
    screenName: 'Stock Transfer',
    label: 'Stock Transfer',
    icon: 'ti ti-transfer-in',
    url: '/dashboard/logistic/stock-transfer-list',
    screenRouteURL: ['/dashboard/logistic/stock-transfer'],
  },
  {
    key: 'logistic',
    rolekey: 'logistic',
    moduleName: 'Logistic Portal',
    screenName: 'Stock Dashboard',
    label: 'Stock Dashboard',
    icon: 'ti ti-dashboard',
    url: '/dashboard/logistic/stock-dashboard',
    screenRouteURL: [
      '/dashboard/logistic/stock-detail'
    ]
  },
  {
    key: 'logistic',
    rolekey: 'logistic',
    moduleName: 'Logistic Portal',
    screenName: 'Device Unlink',
    label: 'Device Unlink',
    icon: 'ti ti-link-minus',
    url: '/dashboard/logistic/device-unlink-list',
    screenRouteURL: [
      '/dashboard/logistic/add-device-unlink'
    ]
  },


  {
    key: 'logistic',
    rolekey: 'logistic',
    label: 'Logistic Reports',
    moduleName: 'Logistic Portal',
    icon: 'ti ti-report',
    collapsed: true,
    showChildren: true,
    children: [
      {
        key: 'logistic',
        rolekey: 'logistic',
        moduleName: 'Logistic Portal',
        screenName: 'Device Setup Scheduling List',
        label: 'Device Setup Scheduling List',
        icon: 'ti ti-clock-12',
        url: '/dashboard/logistic/device-setup-scheduling-list'
      },
       {
        key: 'logistic',
        rolekey: 'logistic',
        moduleName: 'Logistic Portal',
        screenName: 'Device Activity Report',
        label: 'Device Activity Report',
        icon: 'ti ti-activity',
        url: '/dashboard/logistic/device-activity-report'
      },
    ]
    },
  

  //   {
  //   key: 'logistic',
  //   rolekey: 'logistic',
  //   moduleName: 'Logistic Portal',
  //   screenName: 'Device Setup Scheduling',
  //   label: 'Device Setup Scheduling',
  //   icon: 'ti ti-clock-12',
  //   url: '/dashboard/logistic/device-setup-scheduling-screen',   
  // },


  // {
  //   key: 'logistic',
  //   rolekey: 'logistic',
  //   label: 'Logistic Portal',
  //   moduleName: 'Logistic Portal',
  //   icon: 'ti ti-users',
  //   collapsed: true,
  //   showChildren: true,
  //   children: [
  //     {
  //       key: 'patientlistlogisticdashboard',
  //       label: 'Patient Dashboard',
  //       screenName: 'Patient List Logistic Dashboard',
  //       url: '/dashboard/logistic/patient-list-logistic-dashboard',
  //       icon: 'ti ti-device-airtag',
  //       parentKey: 'logistic',
  //     },

  //     {
  //       key: 'returnorderrequest',
  //       label: 'Return Order Request',
  //       screenName: 'Return Order Request',
  //       url: '/dashboard/logistic/return-order-request',
  //       icon: 'ti ti-device-airtag',
  //       parentKey: 'logistic',
  //     },      

  //     {
  //       key: 'returnorderstockreceived',
  //       label: 'Return Order Stock Received',
  //       screenName: 'Return Order Stock Received',
  //       url: '/dashboard/logistic/return-order-stock-received',
  //       icon: 'ti ti-device-airtag',
  //       parentKey: 'logistic',
  //     },
  //     {
  //       key: 'accessoriesorderrequest',
  //       label: 'Accessories Order Request',
  //       screenName: 'Accessories Order Request',
  //       url: '/dashboard/logistic/accessories-order-request',
  //       icon: 'ti ti-device-airtag',
  //       parentKey: 'logistic',
  //     },
  //     {
  //       key: 'accessoriesorderdashboard',
  //       label: 'Accessories Order Dashboard',
  //       screenName: 'Accessories Order Dashboard',
  //       url: '/dashboard/logistic/accessories-order-dashboard',
  //       icon: 'ti ti-device-airtag',
  //       parentKey: 'logistic',
  //     },
  //     {
  //       key: 'accessoriesbulkorder',
  //       label: 'Accessories Bulk Order',
  //       screenName: 'Accessories Bulk Order',
  //       url: '/dashboard/logistic/accessories-bulk-order',
  //       icon: 'ti ti-device-airtag',
  //       parentKey: 'logistic',
  //     },
  //     {
  //       key: 'bulkorderdeviceassignedtopatient',
  //       label: 'Device Assign To Patient',
  //       screenName: 'Device Assign To Patient',
  //       url: '/dashboard/logistic/bulk-order-device-assign-patient',
  //       icon: 'ti ti-device-airtag',
  //       parentKey: 'logistic',
  //     },
  //     {
  //       key: 'demodeviceorderrequest',
  //       label: 'Demo Device Order Request',
  //       screenName: 'Demo Device Order Request',
  //       url: '/dashboard/logistic/demo-device-order-request',
  //       icon: 'ti ti-device-airtag',
  //       parentKey: 'logistic',
  //     },
  //     // {
  //     //   key: 'purchaseorder',
  //     //   label: 'Purchase Order',
  //     //   screenName: 'Purchase Order',
  //     //   url: '/dashboard/logistic/purchase-order-list',
  //     //   icon: 'ti ti-device-airtag',
  //     //   // parentKey: 'logistic',
  //     //   screenRouteURL: ['/dashboard/logistic/purchase-order'],
  //     // },

  //     {
  //       key: 'repairitemrequest',
  //       label: 'Repair Item Request',
  //       screenName: 'Repair Item Request',
  //       url: '/dashboard/logistic/repair-item-request',
  //       icon: 'ti ti-device-airtag',
  //       parentKey: 'logistic',
  //     },
  //     {
  //       key: 'repairitemreturn',
  //       label: 'Repair Item Return',
  //       screenName: 'Repair Item Return',
  //       url: '/dashboard/logistic/repair-item-return',
  //       icon: 'ti ti-device-airtag',
  //       parentKey: 'logistic',
  //     },
  //     {
  //       key: 'ordercancelationdashboard',
  //       label: 'Order Cancelation',
  //       screenName: 'Order Cancelation',
  //       url: '/dashboard/logistic/order-cancelation-dashboard',
  //       icon: 'ti ti-device-airtag',
  //       parentKey: 'logistic',
  //     },
  //     {
  //       key: 'bulkorder',
  //       label: 'Bulk Order',
  //       screenName: 'Bulk Order',
  //       url: '/dashboard/logistic/bulk-order',
  //       icon: 'ti ti-device-airtag',
  //       parentKey: 'logistic',
  //     },
  //   ],
  // },

  {
    key: 'billing',
    rolekey: 'billing',
    label: 'Billing Portal OTD',
    // label: 'Billing Portal',
    moduleName: 'Billing Portal',
    icon: 'ti ti-file-invoice',
    collapsed: true,
    showChildren: true,
    children: [
      {
        key: 'billing',
        label: 'Fee Schedule',
        screenName: 'Fee Schedule',        
        icon: 'ti ti-calendar-clock',      
        url: '/dashboard/billing/add-fee-schedule',
      },
      {
        key: 'billing',
        label: 'New Billing',
        screenName: 'New Billing',        
        icon: 'ti ti-sun-electricity',      
        url: '/dashboard/billing/generate-billing',
      },
      ],
    },   
  //      {
  //   key: 'billing',
  //   rolekey: 'billing',
  //   moduleName: 'Billing Portal',
  //   label: 'Eligibility Criteria',
  //   screenName: 'Eligibility Criteria',
  //   icon: 'ti ti-shield-check',
  //   url: '/dashboard/billing/eligibility-criteria',
  // },

  {
    key: 'billing',
    rolekey: 'billing',
    moduleName: 'Billing Portal',
    screenName: 'Billing List',
    label: 'Billing List',
    icon: 'ti ti-receipt-dollar',
    url: '/dashboard/billing/billing-list',
    screenRouteURL: ['/dashboard/billing/rpm-billing-dashboard',
                     '/dashboard/billing/rtm-billing-dashboard',
                     '/dashboard/billing/pcm-billing-dashboard',
                     '/dashboard/billing/ccm-billing-dashboard',
                     '/dashboard/billing/cocm-billing-dashboard',
    ],   
  },
   {
    key: 'billing',
    rolekey: 'billing',
    moduleName: 'Billing Portal',
    label: 'Claims List',
    screenName: 'Claims List',
    icon: 'ti ti-map-exclamation',
    url: '/dashboard/billing/claims-dashboard',

  },
  
   {
    key: 'billing',
    rolekey: 'billing',
    moduleName: 'Billing Portal',
    label: 'Receipts',
    screenName: 'Receipts',
    icon: 'ti ti-receipt',
    url: '/dashboard/billing/receipt-list',
    screenRouteURL: ['/dashboard/billing/add-payment'],   
  },
          {
    key: 'billing',
    rolekey: 'billing',
    moduleName: 'Billing Portal',
    label: 'Patient Billing',
    screenName: 'Billing Report',
    icon: 'ti ti-credit-card-pay',
    url: '/dashboard/billing/billing-reporting',
  },
     {
    key: 'billing',
    rolekey: 'billing',
    moduleName: 'Billing Portal',
    label: 'Billing Summary',
    screenName: 'Billing Summary',
    icon: 'ti ti-report-money',
    url: '/dashboard/billing/billing-summary',
  },

  {
    key: 'doctor',
    rolekey: 'doctor',
    label: 'Doctor dashboard',
    moduleName: 'Provider Portal',
    icon: 'ti ti-users',
    collapsed: true,
    showChildren: true,
    children: [
      {
        key: 'doctor',
        label: 'Doctor dashboard',
        screenName: 'Doctor dashboard',
        // moduleName:'Care management',
        icon: 'ti ti-dashboard',
        url: '/dashboard/doctor/doctor-dashboard',
        screenRouteURL: ['/dashboard/doctor/doctor-dashboard'],
      },
      {
        key: 'patient-outcomes',
        label: 'Patient Outcomes',
        screenName: 'Patient Outcomes',
        icon: 'ti ti-report-analytics',
        url: '/dashboard/doctor/patient-outcomes',
        screenRouteURL: ['/dashboard/doctor/patient-outcomes'],
      },

    ],
  },
  // {
  //   key: 'reporting',
  //   rolekey: 'reporting',
  //   moduleName: 'Reporting Portal',
  //   screenName: 'Current Month Stats',
  //   label: 'Current Month Stats',
  //   icon: 'ti ti-calendar',
  //   url: '/dashboard/reporting/current-month-stats',
  // },
  {
    key: 'reporting',
    rolekey: 'reporting',
    moduleName: 'Reporting Portal',
    screenName: 'Operational Dashboard',
    label: 'Operational Dashboard',
    icon: 'ti ti-dashboard',
    url: '/dashboard/reporting/operational-dashboard',
  },
  {
    key: 'reporting',
    rolekey: 'reporting',
    moduleName: 'Reporting Portal',
    screenName: 'NP Tracking',
    label: "NP's Tracking",
    icon: 'ti ti-file-search',
    url: '/dashboard/reporting/np-tracking',
  },
  {
    key: 'reporting',
    rolekey: 'reporting',
    moduleName: 'Reporting Portal',
    screenName: 'CM Task Tracker',
    label: 'CM Task Tracker',
    icon: 'ti ti-http-trace',
    url: '/dashboard/reporting/cm-task-tracker',
  },
  {
    key: 'reporting',
    rolekey: 'reporting',
    moduleName: 'Reporting Portal',
    screenName: 'Patients with VML/NoContact',
    label: 'Patients with VML/NoContact',
    icon: 'ti ti-users-group',
    url: '/dashboard/reporting/patients-with-vml',
  },
  // {
  //   key: 'reporting',
  //   rolekey: 'reporting',
  //   moduleName: 'Reporting Portal',
  //   screenName: 'Performance Dashboard',
  //   label: 'Performance Dashboard',
  //   icon: 'ti ti-brand-tabler',
  //   url: '/dashboard/reporting/performance-dashboard',
  // },
  {
    key: 'reporting',
    rolekey: 'reporting',
    moduleName: 'Reporting Portal',
    screenName: 'Patients with Programs',
    label: 'Patients with Programs',
    icon: 'ti ti-user-shield',
    url: '/dashboard/reporting/patients-with-stats',
  },
  // {
  //   key: 'reporting',
  //   rolekey: 'reporting',
  //   moduleName: 'Reporting Portal',
  //   screenName: 'Growth Dashboard',
  //   label: 'Growth Dashboard',
  //   icon: 'ti ti-trending-up',
  //   url: '/dashboard/reporting/growth',
  // },
  // {
  //   key: 'reporting',
  //   rolekey: 'reporting',
  //   moduleName: 'Reporting Portal',
  //   screenName: 'Device Shipment Report',
  //   label: 'Device Shipment Report',
  //   icon: 'ti ti-device-analytics',
  //   url: '/dashboard/reporting/device-shipment-report',
  // },
  {
    key: 'reporting',
    rolekey: 'reporting',
    moduleName: 'Reporting Portal',
    screenName: 'Device Delivery Summary',
    label: 'Device Delivery Summary',
    icon: 'ti ti-invoice',
    url: '/dashboard/reporting/device-delivery-summary',
  },
  {
    key: 'reporting',
    rolekey: 'reporting',
    moduleName: 'Reporting Portal',
    screenName: 'Patients Critical Readings',
    label: "Patient's Critical Readings",
    icon: 'ti ti-message-exclamation',
    url: '/dashboard/reporting/patients-critical-readings',
  },
  {
    key: 'reporting',
    rolekey: 'reporting',
    moduleName: 'Reporting Portal',
    screenName: 'InActive Patients',
    label: 'Active Patients',
    icon: 'ti ti-wheelchair',
    url: '/dashboard/reporting/inactive-patients',
  },
  {
    key: 'reporting',
    rolekey: 'reporting',
    moduleName: 'Reporting Portal',
    screenName: 'Patients & Billing Summary',
    label: 'Patients & Billing Summary',
    icon: 'ti ti-file-invoice',
    url: '/dashboard/reporting/patients-billing-readings',
  },
  {
    key: 'reporting',
    rolekey: 'reporting',
    moduleName: 'Reporting Portal',
    screenName: 'Patient Statistics',
    label: 'Patient Statistics',
    icon: 'ti ti-chart-line',
    url: '/dashboard/reporting/patient-statistics',
  },
  // {
  //   key: 'reporting',
  //   rolekey: 'reporting',
  //   moduleName: 'Reporting Portal',
  //   screenName: 'Weekly Progress Report',
  //   label: 'Weekly Progress Report',
  //   icon: 'ti ti-report-search',
  //   url: '/dashboard/reporting/weekly-progress',
  // },
  {
    key: 'reporting',
    rolekey: 'reporting',
    moduleName: 'Reporting Portal',
    screenName: 'Patient Referrals Review',
    label: "Patient's Referrals Review",
    icon: 'ti ti-arrow-back',
    url: '/dashboard/reporting/patient-referrals-review',
  },
  {
    key: 'reporting',
    rolekey: 'reporting',
    moduleName: 'Reporting Portal',
    screenName: 'Genesis Active Patients',
    label: 'Genesis Active Patients',
    icon: 'ti ti-accessible',
    url: '/dashboard/reporting/genesis-active-patients',
  },
  {
    key: 'reporting',
    rolekey: 'reporting',
    moduleName: 'Reporting Portal',
    screenName: 'Pending Reviews CM',
    label: 'Pending Reviews (CMs)',
    icon: 'ti ti-sort-descending',
    url: '/dashboard/reporting/pending-reviews-cm',
  },

  {
    key: 'reporting',
    rolekey: 'reporting',
    moduleName: 'Reporting Portal',
    screenName: 'Incomplete CPT Codes',
    label: 'Incomplete CPT Codes',
    icon: 'ti ti-select-all',
    url: '/dashboard/reporting/incomplete-cpt-codes',
  },
  {
    key: 'reporting',
    rolekey: 'reporting',
    moduleName: 'Reporting Portal',
    screenName: 'EHR Reports',
    label: 'EHR Reports',
    icon: 'ti ti-http-trace',
    url: '/dashboard/reporting/ehr-reports',
  },
  {
    key: 'reporting',
    rolekey: 'reporting',
    moduleName: 'Reporting Portal',
    screenName: 'Consenting & Retention Reports',
    label: 'Consenting & Retention',
    icon: 'ti ti-confetti',
    url: '/dashboard/reporting/consenting-retention-reports',
  },
  {
    key: 'reporting',
    rolekey: 'reporting',
    moduleName: 'Reporting Portal',
    screenName: 'Device Setup Reports',
    label: 'Device Setup Reports',
    icon: 'ti ti-device-speaker',
    url: '/dashboard/reporting/device-setup-reports',
  },
  {
    key: 'reporting',
    rolekey: 'reporting',
    moduleName: 'Reporting Portal',
    screenName: 'Coorporate Dashboard',
    label: 'Coorporate Dashboard',
    icon: 'ti ti-building-skyscraper',
    url: '/dashboard/reporting/corporate-dashboard',
  },
  {
    key: 'reporting',
    rolekey: 'reporting',
    moduleName: 'Reporting Portal',
    screenName: 'Monthly Consented Report',
    label: 'Monthly Consented Report',
    icon: 'ti ti-report-analytics',
    url: '/dashboard/reporting/monthly-consented-report',
  },
  {
    key: 'reporting',
    rolekey: 'reporting',
    moduleName: 'Reporting Portal',
    screenName: 'Monthly Revenue Report',
    label: 'Monthly Revenue Report',
    icon: 'ti ti-chart-line',
    url: '/dashboard/reporting/monthly-revenue-report',
  },
  {
    key: 'microservice',
    rolekey: 'microservice',
    moduleName: 'Microservice',
    screenName: 'Call Processing',
    label: 'Call Processing',
    icon: 'ti ti-phone',
    url: '/dashboard/microservice/monitoring-portal-dashboard',
  },
  {
    key: 'microservice',
    rolekey: 'microservice',
    moduleName: 'Microservice',
    screenName: 'Automatic call setup',
    label: 'Automatic call setup',
    icon: 'ti ti-ai',
    url: '/dashboard/microservice/automatic-call-setup',
    screenRouteURL: ['/dashboard/microservice/setup-automatic-call'],
  },
  {
    key: 'health',
    rolekey: 'health',
    moduleName: 'Population Health Portal',
    screenName: 'Main',
    label: 'Population Dashboard',
    icon: 'ti ti-dashboard',
    url: '/dashboard/populationhealth/population-health',
  },
   {
    key: 'healthS3',
    rolekey: 'healthS3',
    moduleName: 'Population Health Portal (S3)',
    screenName: 'Main',
    label: 'Population Dashboard',
    icon: 'ti ti-dashboard',
    url: '/dashboard/populationhealth/population-health-s3',
  },
  {
    key: 'analysis',
    rolekey: 'analysis',
    moduleName: 'Analysis Dashboard',
    screenName: 'Main',
    label: 'Dashboard',
    icon: 'ti ti-dashboard',
    url: '/dashboard/analysis/analysis-dashboard',
  },
  {
    key: 'microservice',
    rolekey: 'microservice',
    moduleName: 'Microservice',
    label: 'Log Details',
    icon: 'ti ti-user',
    collapsed: true,
    showChildren: true,
    children: [
      {
        key: 'microservice',
        screenName: 'System Logs',
        label: 'System Logs',
        icon: 'ti ti-logs',
        url: '/dashboard/microservice/system-logs',
        screenRouteURL: ['/dashboard/microservice/add-logs'],
      },
      {
        key: 'microservice',
        rolekey: 'microservice',
        moduleName: 'Microservice',
        screenName: 'System Errors',
        label: 'System Errors',
        icon: 'ti ti-bug',
        url: '/dashboard/microservice/system-errors',
      },
      {
        key: 'microservice',
        rolekey: 'microservice',
        moduleName: 'Microservice',
        screenName: 'System Logs',
        label: 'System Log Parameter',
        icon: 'ti ti-logic-nor',
        url: '/dashboard/microservice/system-logs-basic-parameters',
      },
    ],
  },

  {
    key: 'demoportal',
    rolekey: 'demoportal',
    moduleName: 'Demo Portal',
    screenName: 'Ai Services',
    label: 'AI Services',
    icon: 'ti ti-robot',
    url: '/dashboard/ai/ai-Services-dashboard',
  },
  {
    key: 'sdoh',
    rolekey: 'sdoh',
    label: 'SDOH managers',
    moduleName: 'SDOH Portal',
    icon: 'ti ti-users',
    collapsed: true,
    showChildren: true,
    children: [
      {
        parentKey: 'sdoh',
        key: 'sdoh-dashboard',
        label: 'SDOH Dashboard',
        screenName: 'SDOH Dashboard',
        // moduleName:'Care management',
        icon: 'ti ti-dashboard',
        url: '/dashboard/sdoh/sdoh-dashboard',
      },
    ],
  },
];
